import {
  fetchSuggestionsService,
  fetchLangstonSuggestions,
} from 'static/three-oh/src/components/GlobalLayout/GlobalLayoutV2/NavigationBar/SearchMenu/SearchMenu.services';

export const fetchSuggestions = async({
  fragment = '',
  isLangstonSuggestionsOn,
}) => {
  if (isLangstonSuggestionsOn) {
    const {results} = await fetchLangstonSuggestions(fragment);
    return results;
  } else {
    const {results} = await fetchSuggestionsService(fragment);
    return results;
  }
};
